// @ts-check
import { createApp } from 'vue'
import App from './App.vue'

const rootEl = document.getElementById('app')
const dataset = rootEl?.dataset

createApp(App, {
  errorList: JSON.parse(dataset?.errorList ?? 'null'),
}).mount('#app')
